import { render, staticRenderFns } from "./CheckoutStepChooser.vue?vue&type=template&id=b28f2abc&"
import script from "./CheckoutStepChooser.vue?vue&type=script&lang=js&"
export * from "./CheckoutStepChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CheckoutStepChooser.vue"
export default component.exports